export default __webpack_public_path__ + "static/media/coloregg3.aeac0fc1.png";